export default {
  "Authentication": {
    "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "EN.Gine"
  ])
},
    "subtitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Powered by Enloc"
  ])
},
    "accountGreetingMessage": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Konto: ", _interpolate(_named("accountName"))
  ])
},
    "settingsTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Einstellungen"
  ])
},
    "login": {
      "subtitle": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Bei ", _interpolate(_named("productName")), " anmelden"
  ])
},
      "notExistingAccount": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Dieses Konto kann nicht zugeordnet werden."
  ])
},
      "userName": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Nutzername"
  ])
},
      "password": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Passwort"
  ])
},
      "buttonText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Anmelden"
  ])
},
      "forgotPassword": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Passwort vergessen?"
  ])
},
      "or": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "oder"
  ])
},
      "invalidLoginRequestTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Fehler beim Anmelden"
  ])
},
      "invalidLoginRequestMessage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Es sind keine Login Schemas für diesen Client konfiguriert"
  ])
},
      "registrationTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Noch kein Benutzerkonto?"
  ])
},
      "registrationRedirectButtonText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Registrieren"
  ])
}
    },
    "register": {
      "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Registrierung"
  ])
},
      "caption": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Konto ", _interpolate(_named("account"))
  ])
},
      "subtitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Neuen Benutzer anlegen"
  ])
},
      "email": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "E-Mail"
  ])
},
      "password": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Passwort"
  ])
},
      "confirmPassword": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Passwort bestätigen"
  ])
},
      "buttonText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Registrieren"
  ])
}
    },
    "logout": {
      "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Abmelden"
  ])
},
      "message": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Möchten Sie sich abmelden?"
  ])
},
      "buttonText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Abmelden"
  ])
},
      "back": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zurück"
  ])
}
    },
    "links": {
      "documentation": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Dokumentation"
  ])
},
      "privacyPolicy": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Datenschutz"
  ])
},
      "imprint": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Impressum"
  ])
},
      "support": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Support"
  ])
},
      "copyright": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "© Enloc Port GmbH"
  ])
}
    },
    "manage": {
      "general": {
        "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Benutzerkonto"
  ])
},
        "titleV2": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Kontoinformationen"
  ])
},
        "userRole": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Benutzerrolle"
  ])
},
        "emailConfirmationHint": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Hinweis: bevor Sie sich mit Ihrer neuen E-Mail Adresse anmelden können, muss diese bestätigt werden."
  ])
},
        "email": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ihre E-Mail-Adresse"
  ])
},
        "phone": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ihre Telefonnummer"
  ])
},
        "firstname": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ihre Vorname"
  ])
},
        "lastname": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ihre Nachname"
  ])
},
        "description": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Name Zusatz"
  ])
},
        "saveButtonText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Daten Speichern"
  ])
},
        "confirmEmailButtonText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "E-Mail-Bestätigung anfordern"
  ])
},
        "confirmEmailSent": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bestätigungsmail wurde gesendet. Bitte überprüfen Sie Ihr E-Mail Postfach."
  ])
}
      },
      "password": {
        "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Passworteinstellungen"
  ])
},
        "titleV2": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Sicherheit"
  ])
},
        "saveButtonText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Passwort ändern"
  ])
},
        "oldPassword": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ihr aktuelles Passwort"
  ])
},
        "newPassword": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ihr neues Passwort"
  ])
},
        "confirmNewPassword": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Neues Passwort bestätigen"
  ])
},
        "passwordChanged": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ihr Passwort wurde erfolgreich geändert."
  ])
},
        "passwordsDoNotMatch": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Die Passwörter stimmen nicht überein."
  ])
},
        "passwordRequiresDigit": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Passwörter müssen mindestens eine Ziffer enthalten ('0'-'9')."
  ])
},
        "passwordRequiresLower": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Passwörter müssen mindestens einen Kleinbuchstaben enthalten ('a'-'z')."
  ])
},
        "passwordRequiresNonAlphanumeric": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Passwörter müssen mindestens ein Sonderzeichen enthalten."
  ])
},
        "passwordRequiresUpper": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Passwörter müssen mindestens einen Großbuchstaben enthalten ('A'-'Z')."
  ])
}
      },
      "external": {
        "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Externes Benutzerkonto"
  ])
},
        "disconnectButtonText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Entfernen Sie die folgenden externen Benutzerkonten aus Ihrem Account:"
  ])
},
        "disconnectButtonTextV2": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Entfernen"
  ])
},
        "addNewExternalLoginLabel": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Hier können Sie ein externes Benutzerkonto hinzufügen."
  ])
},
        "disconnectSuccess": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Das externe Benutzerkonto wurde gelöscht."
  ])
}
      }
    },
    "accessDenied": {
      "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zugriff verweigert"
  ])
},
      "message": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Sie haben keinen Zugriff auf diese Ressource."
  ])
}
    },
    "password": {
      "forgot": {
        "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Passwort vergessen"
  ])
},
        "emailTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bitte geben Sie Ihre E-Mail Adresse an."
  ])
},
        "label": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ihre E-Mail Adresse"
  ])
},
        "buttonText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Absenden"
  ])
},
        "notFoundTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Die angegebene E-Mail Addresse wurde nicht gefunden."
  ])
},
        "unexpectedException": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut oder wenden Sie sich an den Support."
  ])
},
        "successMessage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Wir haben Ihnen einen Link zum Zurücksetzen Ihres Passwortes zugeschickt.\nBitte überprüfen Sie Ihre E-Mails."
  ])
}
      },
      "reset": {
        "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Passwort zurücksetzen"
  ])
},
        "subtitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bitte geben Sie Ihre E-Mail Adresse und Ihr neues Passwort ein"
  ])
},
        "email": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "E-Mail"
  ])
},
        "newPassword": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Neues Passwort"
  ])
},
        "confirmPassword": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Neues Passwort bestätigen"
  ])
},
        "passwordsDoNotMatch": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Die eingegebenen Passwörter stimmen nicht überein."
  ])
},
        "successMessage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ihr Passwort wurde erfolgreich zurückgesetzt."
  ])
},
        "invalidToken": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Dieser Link zum Passwort zurücksetzen ist abgelaufen. Hier können Sie einen neuen Link generieren: "
  ])
},
        "buttonText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Passwort zurücksetzen"
  ])
}
      },
      "backToLogin": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zurück zur Anmeldung"
  ])
}
    }
  },
  "ApiClients": {
    "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "API Clients"
  ])
},
    "generateText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Generiere API Client Credentials"
  ])
},
    "exportFileName": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "API Clients_", _interpolate(_named("account"))
  ])
},
    "clientId": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Client ID"
  ])
},
    "generateTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ihre Credentials"
  ])
},
    "clientName": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Client Name"
  ])
},
    "generatedText": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Client Id <strong>", _interpolate(_named("clientId")), "</strong> / Client Secret <strong>", _interpolate(_named("clientSecret")), "</strong> wurde angelegt. Das Secret wird nicht gespeichert und sollte deswegen in 1Password hinterlegt werden. Falls das Löschen eines OpenId Clients oder Secrets gewünscht ist, muss dies noch manuell in der Datenbank vorgenommen werden."
  ])
},
    "url": {
      "engine": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "EN.Gine"
  ])
},
      "enFactsAccounts": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "EN.Facts Accounts"
  ])
},
      "enPowerAccounts": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "EN.Power Accounts"
  ])
}
    }
  },
  "common": {
    "chipInput": {
      "limitHint": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Sie können bis zu ", _interpolate(_named("max")), " Einträge hinterlegen. Trennen Sie mehrere Einträge mit einem Komma oder über die Enter Taste."
  ])
},
      "limitReached": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Maximal ", _interpolate(_named("max")), " Einträge möglich. Bitte entfernen Sie einen Eintrag, um einen neuen hinzuzufügen."
  ])
},
      "pasteTruncated": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Es wurden nur die ersten ", _interpolate(_named("max")), " Einträge übernommen (maximal ", _interpolate(_named("max")), " Einträge möglich)."
  ])
},
      "duplicate": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Doppelte Einträge sind nicht erlaubt und wurden nicht übernommen."
  ])
},
      "removeChip": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    _interpolate(_named("chip")), " entfernen"
  ])
}
    },
    "reauthenticate": {
      "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Sitzung abgelaufen"
  ])
},
      "message": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich im geöffneten Fenster erneut an."
  ])
}
    },
    "yes": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "ja"
  ])
},
    "no": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "nein"
  ])
},
    "dateRelativeToday": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Heute"
  ])
},
    "dateRelativeYesterday": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Gestern"
  ])
},
    "registerToEngine": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bei EN.Gine anmelden"
  ])
},
    "registerWithMicrosoft": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Über Microsoft anmelden"
  ])
},
    "forgotPassword": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Passwort vergessen?"
  ])
},
    "or": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "ODER"
  ])
},
    "newToEngine": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Neu bei EN.Gine?"
  ])
},
    "findOutMore": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Erfahren Sie mehr"
  ])
},
    "recentlyViewed": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zuletzt angesehen"
  ])
},
    "recentlyViewedNumber": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Anzahl"
  ])
},
    "edit": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bearbeiten"
  ])
},
    "save": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Speichern"
  ])
},
    "cancel": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Abbrechen"
  ])
},
    "indexOf": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    _interpolate(_named("index")), " von ", _interpolate(_named("total"))
  ])
},
    "moduleSearch": {
      "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Gehe zu"
  ])
},
      "noSearchResults": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Keine Suchergebnisse"
  ])
},
      "recentlyViewed": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zuletzt angesehen"
  ])
},
      "searchPrompt": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Nach Modulen suchen"
  ])
}
    },
    "overview": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Übersicht"
  ])
},
    "loading": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Wird geladen..."
  ])
},
    "autocompletePlaceholder": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Tippen um zu suchen..."
  ])
},
    "selectPlaceholder": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Auswählen..."
  ])
},
    "noData": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Keine Daten"
  ])
},
    "itemsPerPage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Elemente pro Seite"
  ])
},
    "totalItems": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    _interpolate(_named("totalItems")), " Elemente"
  ])
},
    "errorMessage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Es ist ein Fehler aufgetreten."
  ])
},
    "upload": {
      "label": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Hochladen"
  ])
},
      "progress": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Hochladen..."
  ])
},
      "dragDropLabel": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Datei hierher ziehen oder Klicken zum Hochladen"
  ])
}
    },
    "notifications": {
      "clear": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Es ist alles erledigt. Das war ein produktiver Tag!"
  ])
},
      "markAllNotificationsAsRead": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Alle als gelesen markieren"
  ])
},
      "new": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Neu"
  ])
},
      "all": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Gelesen"
  ])
},
      "downloadFiles": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Datei herunterladen"
  ])
},
      "loadingMore": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Weitere werden geladen..."
  ])
}
    },
    "errorBoundary": {
      "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Etwas ist schief gelaufen!"
  ])
},
      "messageShort": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Es ist ein Fehler aufgetreten."
  ])
},
      "messagePage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut."
  ])
},
      "backButtonText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zurück"
  ])
},
      "returnToHomePage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zurück zur Startseite"
  ])
},
      "errorCode": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "404"
  ])
},
      "pageNotFoundMessage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Diese Seite existiert nicht oder kann nicht gefunden werden.\nStellen Sie sicher, dass die URL korrekt ist."
  ])
}
    },
    "validation": {
      "required": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Pflichtfeld"
  ])
},
      "maxLength": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Eingabe ist zu lang (maximal ", _interpolate(_named("max")), " Zeichen)"
  ])
},
      "minLength": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Eingabe ist zu kurz (mindestens ", _interpolate(_named("min")), " Zeichen)"
  ])
},
      "exactLength": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Eingabe muss genau ", _interpolate(_named("len")), " Zeichen lang sein."
  ])
},
      "numberConstraints": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Wert liegt außerhalb des zulässigen Bereichs (mindestens ", _interpolate(_named("min")), _interpolate(_named("maxPart")), ")"
  ])
},
      "numberConstraintsMaxPart": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    " und maximal ", _interpolate(_named("max"))
  ])
},
      "onlyPositiveNumbers": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Wert ist keine positive Zahl"
  ])
},
      "onlyInteger": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bitte geben Sie eine Ganzzahl ein"
  ])
},
      "validEmail": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bitte geben Sie eine gültige Email-Adresse ein"
  ])
},
      "validPhone": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bitte geben Sie ein gültig Telefone ein (+4912345678901)"
  ])
},
      "meterCount": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bitte geben Sie einen validen Zählerstand an"
  ])
}
    },
    "address": {
      "generic": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Adresse"
  ])
},
      "postalCode": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "PLZ"
  ])
},
      "city": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Stadt"
  ])
},
      "street": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Straße"
  ])
},
      "streetFull": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Straße/Hausnummer"
  ])
},
      "label": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bezeichnung"
  ])
},
      "houseNumber": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Hausnummer"
  ])
},
      "houseNumberSuffix": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Hausnummerzusatz"
  ])
},
      "position": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Lage"
  ])
},
      "enKey": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Wohnungsnummer"
  ])
},
      "objectKey": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Objektschlüssel"
  ])
},
      "externalNumber": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ihre Nummer"
  ])
},
      "consumptionPointType": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Verbrauchsstellenart"
  ])
}
    },
    "cards": {
      "noDataCard": {
        "defaultMessage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Keine Daten vorhanden."
  ])
},
        "addEntryMessage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Fügen Sie den ersten Eintrag hinzu!"
  ])
}
      }
    },
    "snackbar": {
      "copyToClipboardMessage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "In die Zwischenablage kopiert!"
  ])
},
      "saved": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Änderungen erfolgreich gespeichert"
  ])
},
      "deleted": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Eintrag erfolgreich gelöscht"
  ])
}
    },
    "restrictedAccess": {
      "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Dieses Modul ist für Ihren Zugang nicht freigeschaltet."
  ])
},
      "text": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bitte kontaktieren Sie Ihren Ansprechpartner/Administrator oder direkt unseren Kundenservice."
  ])
},
      "contactButton": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Kundenservice kontaktieren"
  ])
},
      "backButton": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zurück zur letzten Seite"
  ])
}
    },
    "buttons": {
      "cancel": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Abbrechen"
  ])
},
      "login": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Einloggen"
  ])
},
      "close": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Schließen"
  ])
},
      "save": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Speichern"
  ])
},
      "previous": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Vorheriger Eintrag"
  ])
},
      "next": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Nächster Eintrag"
  ])
},
      "delete": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Löschen"
  ])
},
      "add": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Hinzufügen"
  ])
},
      "sort": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Sortieren"
  ])
},
      "sortDirections": {
        "ascending": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Aufsteigend"
  ])
},
        "descending": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Absteigend"
  ])
}
      },
      "feedback": {
        "success": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Erfolgreich"
  ])
},
        "error": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Fehler"
  ])
}
      },
      "imitate": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Imitieren"
  ])
}
    },
    "detailsDialog": {
      "position": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    _interpolate(_named("position")), " von ", _interpolate(_named("total"))
  ])
},
      "saveSuccess": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Die Änderungen wurden gespeichert."
  ])
},
      "saveError": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Die Änderungen konnten nicht gespeichert werden."
  ])
}
    },
    "unsavedChanges": {
      "count": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx
  return _plural([
    _normalize([
      _interpolate(_named("n")), " ungespeicherte Änderung"
    ]), _normalize([
      _interpolate(_named("n")), " ungespeicherte Änderungen"
    ])
  ])
},
      "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Sie haben ungespeicherte Änderungen"
  ])
},
      "changedFields": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx
  return _plural([
    _normalize([
      "Sie haben ", _interpolate(_named("n")), " Feld geändert."
    ]), _normalize([
      "Sie haben ", _interpolate(_named("n")), " Felder geändert."
    ])
  ])
},
      "changedFieldsIn": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx
  return _plural([
    _normalize([
      "Sie haben ", _interpolate(_named("n")), " Feld in ", _interpolate(_named("item")), " geändert."
    ]), _normalize([
      "Sie haben ", _interpolate(_named("n")), " Felder in ", _interpolate(_named("item")), " geändert."
    ])
  ])
},
      "hint": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Speichern oder verwerfen Sie die Änderungen. Schließen Sie den Dialog, um weiter zu bearbeiten."
  ])
},
      "discard": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Änderungen verwerfen"
  ])
},
      "saveAndClose": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Speichern und schließen"
  ])
},
      "saveAndContinue": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Speichern und weiter"
  ])
}
    },
    "resizable": {
      "handle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ziehen, um die Breite zu ändern · Doppelklick zum Zurücksetzen"
  ])
}
    },
    "error": {
      "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Es ist ein Fehler aufgetreten"
  ])
},
      "unknown": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut."
  ])
}
    },
    "empty": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "leer"
  ])
},
    "dataGrid": {
      "noWarnings": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Keine Warnungen"
  ])
},
      "columnEdit": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Spalten bearbeiten"
  ])
},
      "columnHide": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ausblenden"
  ])
},
      "columnShowAll": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Alle Spalten anzeigen"
  ])
},
      "columnRestoreDefaultView": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Standardansicht wiederherstellen"
  ])
},
      "columnReorder": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Reihenfolge ändern"
  ])
},
      "columnsButtonText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Spalten"
  ])
},
      "add": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Hinzufügen"
  ])
},
      "addNewAccount": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Neuen Eintrag hinzufügen"
  ])
},
      "cancel": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Abbrechen"
  ])
},
      "confirm": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bestätigen"
  ])
},
      "exactSearch": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Exakte Suche"
  ])
},
      "delete": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Löschen"
  ])
},
      "deleteTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Eintrag löschen"
  ])
},
      "deleteText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Der Eintrag kann nicht wieder hergestellt werden. Möchten Sie den Eintrag wirklich löschen?"
  ])
},
      "actionsTooltip": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Aktionen"
  ])
},
      "copyTooltip": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Kopieren"
  ])
},
      "deleteTooltip": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Löschen"
  ])
},
      "editTooltip": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Editieren"
  ])
},
      "create": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Erstellen"
  ])
},
      "edit": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Übernehmen"
  ])
},
      "addTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Eintrag hinzufügen"
  ])
},
      "editTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Eintrag editieren"
  ])
},
      "startGuide": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Führung"
  ])
},
      "selectAll": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Alle"
  ])
},
      "selectYes": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ja"
  ])
},
      "selectNo": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Nein"
  ])
},
      "clearSort": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Sortierung aufheben"
  ])
},
      "filterType": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Filtertyp"
  ])
},
      "filter": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Filter"
  ])
},
      "resetFilters": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Filter zurücksetzen"
  ])
},
      "exportButtonText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Export"
  ])
},
      "selectedText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    " ausgewählt"
  ])
},
      "exportAll": {
        "label": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Daten exportieren"
  ])
},
        "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Dokument vorbereiten"
  ])
},
        "finishText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ihr Export ist bereit! Sie können die Datei nicht finden? Überprüfen Sie den Download-Ordner"
  ])
},
        "cancelText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Der Download wird abgebrochen. Sie können das Fenster schließen."
  ])
},
        "errorText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Es ist ein Fehler aufgetreten. Der Download wird abgebrochen. Sie können das Fenster schließen."
  ])
},
        "tooManyRowsText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ihr Export überschreitet 50.000 Datensätze. Bitte setzen Sie Filter, um die Datenmenge zu reduzieren."
  ])
},
        "text": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Export wird vorbereitet..."
  ])
},
        "close": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Schließen"
  ])
},
        "export": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Klicken Sie hier um erneut zu downloaden."
  ])
}
      },
      "exportAllVisible": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Sichtbare Daten exportieren"
  ])
},
      "exportSelected": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ausgewählte Daten exportieren"
  ])
},
      "postError": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Fehler beim Hinzufügen"
  ])
},
      "putError": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Fehler beim Editieren"
  ])
},
      "deleteError": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Fehler beim Löschen"
  ])
},
      "autocompleteFilterHint": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    _interpolate(_named("label")), " enthält"
  ])
},
      "actions": {
        "phone": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Nummer anrufen"
  ])
},
        "email": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "E-Mail versenden"
  ])
},
        "general": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Allgemeine Aktionen"
  ])
},
        "reload": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Daten aktualisieren"
  ])
},
        "batchProcess": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Stapelverarbeitung"
  ])
},
        "moduleActions": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Weitere Aktionen"
  ])
},
        "tooltip": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Weitere Aktionen"
  ])
}
      },
      "batchProcess": {
        "tooltip": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Stapelverarbeitung"
  ])
},
        "tooltipDisabled": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Wählen sie mindestens eine Zeile aus, um die Stapelverarbeitung zu aktivieren."
  ])
}
      },
      "noData": {
        "text": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Keine Daten vorhanden"
  ])
},
        "description": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Für diese Ansicht liegen aktuell keine Daten vor."
  ])
},
        "filtersExist": {
          "text": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Keine Ergebnisse gefunden"
  ])
},
          "description": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ändere oder entferne einzelne Filter, um passende Ergebnisse anzuzeigen."
  ])
}
        }
      }
    },
    "filters": {
      "manageFilters": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Filter verwalten"
  ])
},
      "clearFilters": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Filter löschen"
  ])
},
      "hideAllFilters": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Alle Filter ausblenden"
  ])
},
      "showAllFilters": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Alle Filter anzeigen"
  ])
},
      "apply": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Anwenden"
  ])
},
      "reset": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zurücksetzen"
  ])
},
      "noFilterText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "nicht gesetzt"
  ])
},
      "=": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "ist gleich"
  ])
},
      "<": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "kleiner als"
  ])
},
      ">": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "größer als"
  ])
},
      "contains": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "enthält"
  ])
},
      "like": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "flexibel"
  ])
},
      "startsWith": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "beginnt mit"
  ])
}
    },
    "inputs": {
      "readonlyHint": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Kann nicht bearbeitet werden"
  ])
},
      "error": {
        "isMandatory": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Pflichtfeld"
  ])
}
      }
    },
    "dropIn": {
      "dropInTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Drag & Drop"
  ])
},
      "dropInTitleError": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Etwas ist schief gelaufen"
  ])
},
      "dropInTitleSuccess": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Erfolgreich verarbeitet!"
  ])
},
      "dropInTitleLoading": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Dateien werden verarbeitet..."
  ])
},
      "dropInText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Legen Sie Ihre Dateien hier ab oder klicken Sie, um nach Dateien zu suchen"
  ])
},
      "errorText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Beim Verarbeiten der Dateien ist ein Fehler aufgetreten"
  ])
}
    },
    "stepper": {
      "back": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zurück"
  ])
},
      "continue": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Weiter"
  ])
},
      "finish": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Abschließen"
  ])
}
    },
    "meterReadingValueField": {
      "preCommaLabel": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Vorkommastellen"
  ])
},
      "postCommaLabel": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Nachkommastellen"
  ])
},
      "errors": {
        "isEmpty": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Vorkommastellen müssen angegeben werden"
  ])
},
        "isNan": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zählerstand ist ungültig (kein valider Zahlenwert)"
  ])
},
        "notAnInteger": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zählerstand ist ungültig (kein valider Zahlenwert)"
  ])
},
        "isZero": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zählerstand liegt bei 0"
  ])
},
        "outOfBounds": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zählerstand ist ungültig (maximal 6 Vor- und 4 Nachkommastellen)"
  ])
},
        "prognosisDoesNotFit": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zählerstand weicht stark von der Prognose ab"
  ])
},
        "isSmallerThanPreviousValue": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zählerstand ist kleiner als der vorherige Stand"
  ])
}
      }
    },
    "meterReadingForm": {
      "dateLabel": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ablesedatum"
  ])
},
      "commentLabel": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Kommentar"
  ])
},
      "commentInfo": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Sie können nach Angabe eines Kommentars speichern"
  ])
},
      "commentHint": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bitte geben Sie einen Kommentar an"
  ])
},
      "statusLabel": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Status"
  ])
}
    },
    "meterDetailsPage": {
      "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zähler"
  ])
},
      "objectKey": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Objektschlüssel"
  ])
},
      "metersTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Übersicht Zählerstände"
  ])
},
      "readingSpan": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Zeitraum vom ", _interpolate(_named("first")), " bis ", _interpolate(_named("last"))
  ])
},
      "currentMeterReading": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "aktueller Zählerstand"
  ])
},
      "oldMeterReading": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "alter Zählerstand"
  ])
},
      "addMeterReading": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zählerstand hinzufügen"
  ])
},
      "counters": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx
  return _plural([
    _normalize([
      "keine Zählwerke"
    ]), _normalize([
      "Zählwerk"
    ]), _normalize([
      _interpolate(_named("count")), " Zählwerke"
    ])
  ])
},
      "objectSubtitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Verbrauchsstelle"
  ])
},
      "meterSubtitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zählerinformationen"
  ])
},
      "columns": {
        "reading": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ablesung"
  ])
},
        "editor": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bearbeiter"
  ])
},
        "comment": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Kommentar"
  ])
},
        "reportedAt": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ablesedatum"
  ])
}
      },
      "addReadingDialog": {
        "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zählerstand hinzufügen"
  ])
},
        "confirm": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Hinzufügen"
  ])
}
      },
      "loadingErrorMessage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Fehler beim Laden der Daten. Bitte versuchen Sie es später noch einmal."
  ])
}
    },
    "help": {
      "contactQuestion": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Haben Sie Fragen?"
  ])
},
      "contactButtonText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Kontakt aufnehmen"
  ])
},
      "contactButtonSubject": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "EN.Gine Portal Kundenservice Anfrage"
  ])
},
      "writeEmailToCustomerServiceTooltip": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Kundenservice kontaktieren"
  ])
},
      "frequentlyAskedQuestions": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "FAQ und Hinweise"
  ])
},
      "documentation": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Nutzerhandbuch"
  ])
},
      "infoButtonTooltip": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Seitenüberblick & Navigation"
  ])
},
      "pageInformation": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Information"
  ])
},
      "imprint": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Impressum"
  ])
},
      "privacyPolicy": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Datenschutz"
  ])
}
    },
    "pdf": {
      "previewError": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ihr Browser unterstützt die Anzeige von PDFs nicht."
  ])
},
      "previewDownloadError": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "PDF konnte nicht gefunden werden."
  ])
},
      "loadError": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "PDF konnte nicht geladen werden."
  ])
},
      "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "PDF"
  ])
},
      "open": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Öffnen"
  ])
},
      "download": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Download"
  ])
}
    },
    "messageType": {
      "success": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Erfolg"
  ])
},
      "information": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Information"
  ])
},
      "warning": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Warnung"
  ])
},
      "critical": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Kritisch"
  ])
},
      "error": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Fehler"
  ])
}
    },
    "dashboard": {
      "title": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Startseite"
  ])
},
      "openInvoices": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Offene Rechnungen"
  ])
},
      "meterReadings": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zählerstände"
  ])
},
      "consumptionPoints": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Verbrauchsstellen"
  ])
},
      "advancePaymentInfo": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Abschlagsmitteilungen"
  ])
},
      "searchPlaceholder": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "In Modulen suchen..."
  ])
},
      "accountContextMenuHeading": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Benutzerkonto"
  ])
},
      "accountSettings": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Einstellungen"
  ])
},
      "signOut": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Abmelden"
  ])
},
      "imitateUser": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Nutzer imitieren"
  ])
},
      "accountSection": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Account"
  ])
},
      "imitateUserDialogText": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Suchen Sie nach der E-Mail des Nutzers, den Sie imitieren möchten."
  ])
},
      "imitateUserEmailInputLabel": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Nutzer E-Mail"
  ])
}
    }
  },
  "meter": {
    "states": {
      "Locked": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Gesperrt"
  ])
},
      "Removed": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ausgebaut"
  ])
},
      "Active": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Aktiv"
  ])
}
    },
    "readingTypes": {
      "EC": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Über Kundenimport geliefert"
  ])
},
      "EM": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Über EN.Count Mobile gemeldet"
  ])
},
      "EW": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Über EN.Count Web gemeldet"
  ])
},
      "default": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Unbekannte Ableseart"
  ])
}
    },
    "energyTypes": {
      "E": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Strom"
  ])
},
      "G": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Gas"
  ])
},
      "W": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Wasser"
  ])
},
      "V": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Wärme"
  ])
},
      "O": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Öl"
  ])
},
      "A": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Abwasser"
  ])
},
      "T": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Fernwärme/Wärme"
  ])
},
      "D": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Fernwärme"
  ])
},
      "C": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Kaltwasser"
  ])
},
      "H": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Warmwasser"
  ])
},
      "S": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Unbekannt"
  ])
}
    },
    "meterReadingColumn": {
      "highTariff": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Hochtarif"
  ])
},
      "lowTariff": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Niedertarif"
  ])
},
      "meterReading": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zählerstand"
  ])
},
      "noReadingData": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Keine Daten"
  ])
},
      "meterReadingDetails": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zählerstanddetails"
  ])
},
      "readingDate": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ablesedatum"
  ])
}
    }
  },
  "consumptionPoint": {
    "consumptionPoint": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Verbrauchsstelle"
  ])
},
    "consumptionPointType": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Art"
  ])
},
    "label": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bezeichnung"
  ])
}
  },
  "customer": {
    "customer": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Kunde"
  ])
},
    "customerNumber": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Kundennummer"
  ])
},
    "malo": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Malo-IDs"
  ])
}
  },
  "advancePaymentInfo": {
    "advancePaymentInfo": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Abschlagsmitteilung"
  ])
},
    "plural": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Abschlagsmitteilungen"
  ])
}
  },
  "invoice": {
    "invoice": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Rechnung"
  ])
},
    "headerDocument": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Dokumente"
  ])
},
    "headerInvoiceFile": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "PDF"
  ])
},
    "headerXInvoiceFile": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "XRechnung"
  ])
}
  },
  "guide": {
    "tableTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Tabelle"
  ])
},
    "table": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>In der Tabelle finden Sie relevante Daten.</div> \n        <div>Die Spaltenüberschriften finden Sie im Tabellenkopf, die tatsächlichen Daten darunter.</div> "
  ])
},
    "headerTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Tabellenkopf"
  ])
},
    "header": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Im Tabellenkopf können Sie die Spaltenüberschriften sehen und diverse Einstellungen vornehmen.</div>"
  ])
},
    "rowTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Tabellenzeilen"
  ])
},
    "row": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Darunter finden Sie die tatsächlichen Daten.</div>"
  ])
},
    "actionTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Aktionen"
  ])
},
    "action": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>In der letzten Spalte finden Sie die Aktionen, die Sie für den jeweiligen Datensatz ausführen können.</div>"
  ])
},
    "addItemTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Datensatz hinzufügen"
  ])
},
    "addItem": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Über diesen Button können Sie einen neuen Datensatz hinzufügen.</div>"
  ])
},
    "editItemTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Aktionen: Datensatz editieren"
  ])
},
    "editItem": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Über diesen Button können Sie einen Datensatz editieren.</div>"
  ])
},
    "copyItemTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Aktionen: Datensatz kopieren"
  ])
},
    "copyItem": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Über diesen Button können Sie einen Datensatz kopieren. Sie können den Datensatz anpassen, bevor Sie ihn speichern.</div>"
  ])
},
    "deleteItemTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Aktionen: Datensatz löschen"
  ])
},
    "deleteItem": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Über diesen Button können Sie einen Datensatz entfernen.</div>"
  ])
},
    "menuTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Menü"
  ])
},
    "menu": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Über diese Aktion können Sie das Menü für einen spezifischen Datensatz öffnen.</div>"
  ])
},
    "additionalActionTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Weitere Aktionen"
  ])
},
    "additionalAction": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Hier finden Sie weitere Aktionen, die für den Datensatz durchgeführt werden können.</div>"
  ])
},
    "pagination": {
      "mainTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Pagination"
  ])
},
      "main": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Hier finden Sie Informationen zum Datenbestand</div>"
  ])
},
      "elementsPerPageTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Pagination: Elemente pro Seite"
  ])
},
      "elementsPerPage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Hier können Sie einstellen, wie viele Elemente Sie pro Seite sehen.</div>"
  ])
},
      "currentElementsTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Pagination: Aktuelle Elemente"
  ])
},
      "currentElements": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Hier können Sie sehen, welche Datensätze Sie gerade einsehen, im Verhältnis zur Gesamtmenge.</div>"
  ])
},
      "currentPageTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Pagination: Aktuelle Seite"
  ])
},
      "currentPage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Hier können Sie sehen, auf welcher Seite Sie sich derzeit befinden.</div>"
  ])
},
      "firstPageTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Pagination: Erste Seite"
  ])
},
      "firstPage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Über dieses Icon gelangen Sie zurück zur ersten Seite.</div>"
  ])
},
      "previousPageTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Pagination: Vorherige Seite"
  ])
},
      "previousPage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Über dieses Icon gelangen Sie zurück zur vorherigen Seite.</div>"
  ])
},
      "nextPageTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Pagination: Nächste Seite"
  ])
},
      "nextPage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Über dieses Icon gelangen Sie weiter zur nächsten Seite.</div>"
  ])
},
      "lastPageTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Pagination: Letzte Seite"
  ])
},
      "lastPage": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Über dieses Icon gelangen Sie weiter zur letzten Seite.</div>"
  ])
}
    },
    "expandTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Datensatz ausklappen"
  ])
},
    "expand": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Über dieses Icon können Sie den Datensatz ausklappen.</div>"
  ])
},
    "selectTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Datensatz selektieren"
  ])
},
    "select": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Über dieses Icon können Sie einen Datensatz selektieren.</div>"
  ])
},
    "selectAllTitle": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Mehrere Datensätze selektieren"
  ])
},
    "selectAll": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "<div>Über dieses Icon können Sie alle Datensätze selektieren.</div> \n<ul class=\"step-list\">\n<li>Ist das Icon leer, sind keine Zeilen ausgewählt.</li>\n<li>Ist ein Minus zu sehen, sind einige Zeilen ausgewählt.</li>\n<li>Ist ein Haken zu sehen, sind alle Zeilen ausgewählt.</li>\n</ul>"
  ])
},
    "previous": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Schritt zurück"
  ])
},
    "next": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Weiter"
  ])
}
  },
  "notifications": {
    "new": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Neu"
  ])
},
    "all": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Gelesen"
  ])
},
    "markAsRead": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Alle als gelesen markieren"
  ])
},
    "obsoleteUrl": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Die URL ist nicht mehr gültig."
  ])
}
  },
  "genericForm": {
    "countryName": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Land"
  ])
},
    "postalCode": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "PLZ"
  ])
},
    "city": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ort"
  ])
},
    "street": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Straße"
  ])
},
    "houseNumber": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Hausnummer"
  ])
},
    "houseNumberSuffix": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Hausnummerzusatz"
  ])
},
    "label": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bezeichnung"
  ])
},
    "position": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Lage"
  ])
},
    "dateCreated": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Erstellt am"
  ])
},
    "email": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Email"
  ])
},
    "numberOfAddresses": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Anzahl"
  ])
},
    "customer": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Kunde"
  ])
},
    "isActual": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ist aktuelle Adresse"
  ])
}
  },
  "navigation": {
    "EnFacts": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "EN.Facts - Digitale Immobilienwirtschaft"
  ])
},
    "Account": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Account"
  ])
},
    "EnFactsAccountInfoManagement": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Account Einstellungen"
  ])
},
    "EnTab": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "EN.Tab"
  ])
},
    "Protocols": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Protokolle"
  ])
},
    "LicenseManagement": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Lizenzmanagement"
  ])
},
    "ProtocolTemplates": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Protokollvorlagen"
  ])
},
    "RentalData": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bestandsdaten"
  ])
},
    "RentalDataSearch": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Bestandsdaten"
  ])
},
    "EnFactsCsvImport": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Import Management"
  ])
},
    "EnCount": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zählerstandserfassung"
  ])
},
    "EnPower_EnCount_web": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Ablesungen"
  ])
},
    "EnCountMobile": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zur mobilen EN.Count App"
  ])
},
    "EnPower": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "EN.Power - Digitaler Energieversorger"
  ])
},
    "CustomerPortal": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Kundenportal"
  ])
},
    "EnflowEnloc": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Leerstandsmanagement"
  ])
},
    "EnPower_EnCrm_Customers": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Kunden"
  ])
},
    "EnPower_EnCrm_Meters": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Zähler"
  ])
},
    "EnPower_EnVoice_Invoices": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Rechnungen"
  ])
},
    "EnPower_EnVoice_AdvancePaymentInfos": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Abschlagsmitteilungen"
  ])
},
    "InvoiceWarnings": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Mahnungen"
  ])
},
    "Deliveries": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Belieferungen"
  ])
},
    "EnPower_EnCrm_Contracts": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Lieferverträge"
  ])
},
    "EnFlow_SupplymentRequestReport": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Leerstand melden"
  ])
},
    "Crm": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Belieferungskonfiguration"
  ])
},
    "MarketPartnerContacts": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "EN.Solver Marktpartnermanagement"
  ])
},
    "SupplymentRequestSearch": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Belieferungsanfragen"
  ])
},
    "SupplymentManagement": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Belieferungsmanagement"
  ])
},
    "MsconsCases": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Marktnachrichten"
  ])
},
    "EnPowerTools": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Tools für Energieversorger"
  ])
},
    "EnKeyCorrection": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "kVASy-Objektschlüsselkorrektur"
  ])
},
    "ChangeRequestManagement": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Änderungsanfragen"
  ])
},
    "KvasyActivities": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "kVASy Aktivitäten anlegen"
  ])
},
    "DeliveryConfigurations": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Versandeinstellungen"
  ])
},
    "EnVoiceUpload": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Dateiupload"
  ])
},
    "CustomerPermissions": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Kundenberechtigungen"
  ])
},
    "DeliveryProcessManagement": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "EN.Send Journal"
  ])
},
    "Admin": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Administration"
  ])
},
    "UserAndAccounts": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Nutzer & Accounts"
  ])
},
    "UserManagement": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Nutzer"
  ])
},
    "EnFactsAccountManagement": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "EN.Facts Accounts"
  ])
},
    "EnPowerAccountManagement": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "EN.Power Accounts"
  ])
},
    "Miscellaneous": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Sonstiges"
  ])
},
    "Statistics": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Statistiken"
  ])
},
    "ContractCenter": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Software-Vertragscenter"
  ])
},
    "AuditLogs": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Aktivitätenübersicht"
  ])
},
    "Development": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Development"
  ])
},
    "ComponentDoc": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Component Documentation"
  ])
}
  },
  "errors": {
    "datagrid": {
      "GenericDatabaseError": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Ein unerwarteter Datenbankfehler ist aufgetreten: ", _interpolate(_named("message"))
  ])
},
      "ForeignKey": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Der Eintrag in Tabelle '", _interpolate(_named("table")), "' kann nicht gespeichert werden, da die Verknüpfung für '", _interpolate(_named("column")), "' ungültig ist."
  ])
},
      "DuplicateKey": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "In der Tabelle '", _interpolate(_named("table")), "' existiert bereits ein Eintrag mit dem Wert für '", _interpolate(_named("column")), "'."
  ])
},
      "NotNullViolation": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Das Feld '", _interpolate(_named("column")), "' in der Tabelle '", _interpolate(_named("table")), "' darf nicht leer sein."
  ])
},
      "CheckConstraintViolation": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Der Wert für '", _interpolate(_named("column")), "' in der Tabelle '", _interpolate(_named("table")), "' verletzt die Bedingung '", _interpolate(_named("constraint")), "'."
  ])
},
      "CastNonNullableException": (ctx) => {
  const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx
  return _normalize([
    "Ein ungültiger Wert wurde für das Feld '", _interpolate(_named("property")), "' in der Tabelle '", _interpolate(_named("table")), "' übergeben."
  ])
},
      "DatabaseUnavailable": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Die Datenbank ist derzeit nicht erreichbar. Bitte versuchen Sie es später erneut."
  ])
},
      "FreshSessionRequired": (ctx) => {
  const { normalize: _normalize } = ctx
  return _normalize([
    "Sitzung abgelaufen – bitte erneut anmelden und die Aktion wiederholen."
  ])
}
    }
  }
};